import makeApiRequest from './makeApiRequest';

export default async function getGDPR(account, instance) {
    return await makeApiRequest(account, instance, 'get', 'GetGDPRAuth');
}